export default __webpack_public_path__ + "static/P9-10_740A1478-de4debc90675201f9b1e4c1c2048b391.jpg";